import { DEV_BRAND_PORTS, ROVER_DEV_HOSTS } from '@rover/constants/src/platform/hosts.constants';
import { RoverBrand } from '@rover/types/src/RoverBrand';

/**
 * The non-Rover brand a development port serves on `host` (`hostname:port`), or null. The
 * Rover port returns null so the hostname still decides, keeping `ciaf.local:8001` Cat in a Flat.
 */
export const getDevBrand = (host: string): RoverBrand | null => {
  const brand = DEV_BRAND_PORTS[host.split(':')[1] ?? ''];
  return brand && brand !== RoverBrand.Rover ? brand : null;
};

/** The development port that serves `brand`, or undefined for a brand with none. */
export const getDevBrandPort = (brand: RoverBrand): string | undefined =>
  Object.keys(DEV_BRAND_PORTS).find((port) => DEV_BRAND_PORTS[port] === brand);

/**
 * The same hostname on the port serving `brand`, or null unless `host` is a Rover dev host on a
 * brand port (so never in production or staging) and `brand` has a port.
 */
export const getDevHostForBrand = (host: string, brand: RoverBrand): string | null => {
  const [hostname, port = ''] = host.split(':');
  const brandPort = getDevBrandPort(brand);
  if (!brandPort || !(port in DEV_BRAND_PORTS) || !ROVER_DEV_HOSTS.test(hostname)) {
    return null;
  }
  return `${hostname}:${brandPort}`;
};
